export const generateRandomNumber = (range = 100) => {
  return Math.ceil(Math.random() * range);
};
